import { Directive, Input, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[panel-toggle]'
})
export class PanelToggleDirective {
  @Input('panel-toggle') targetSelector: string;
  @Input() options: ToggleOptions = {
    toggleDisplay: true,
    toggleClasses: []
  };

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    const targetElement = document.querySelector(this.targetSelector);
    if (targetElement) {
      if (this.options.toggleDisplay) {
        const isCurrentlyVisible = getComputedStyle(targetElement).display !== 'none';
        this.renderer.setStyle(targetElement, 'display', isCurrentlyVisible ? 'none' : 'block');
      }
      if (this.options.toggleClasses && this.options.toggleClasses.length > 0) {
        this.options.toggleClasses.forEach(cls => {
          if (targetElement.classList.contains(cls)) {
            this.renderer.removeClass(targetElement, cls);
          } else {
            this.renderer.addClass(targetElement, cls);
          }
        });
      }
    }
  }
}

interface ToggleOptions {
  toggleDisplay?: boolean;
  toggleClasses?: string[];
}
